// extracted by mini-css-extract-plugin
module.exports = {"share":"share_share__1wK0a","ready":"share_ready__2o_t0"};